import * as types from './mutation-types'

export const ActionLimparCollpase = ({ commit, state }, collapse) => {
  commit(types.LIMPAR_DADOS_COLLAPSE_RECURSOS, collapse)
}

export const ActionDefinirCollpase = ({ commit, state }, collapse) => {
  const novoPayload = {
    ...state.collapsedItems,
    ...collapse
  }
  commit(types.SET_DADOS_COLLAPSE_RECURSOS, novoPayload)
}
